import { Col as ColAntD, Row as RowAntD } from 'antd';
import styled from 'styled-components';

export const Row = styled(RowAntD)`
  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }

  .ant-switch-checked {
    background-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const SwitchWrapper = styled.div<{ errors?: any }>`
  padding: 8px 0;
  margin-bottom: 39px;
`;

export const Col = styled(ColAntD)`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const ColException = styled(ColAntD)`
  display: flex;
  gap: 8px;
`;

export const FieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;

  input::placeholder {
    font-weight: 300;
  }
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 15px;
`;

export const MessageBox = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;
